import debounce from 'lodash.debounce'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  // Button,
  FormDashboardTextarea as Textarea,
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  FormRow,
  RequiredLabel,
  SpecialRequiredLabel,
  ImagePickerSidebar,
} from '../../../components'
import { useInternationalization } from '../../../features/i18n'
import { updateForm } from '../../../features/resource-form/slice'
import { useViewport } from '../../../utils'
import { FormOptions } from './form-options'
import { SidebarStatus } from './sidebar-status'

const Form = ({ isEdit }) => {
  const dispatch = useDispatch()
  const form = useSelector(state => state.resourceForm.data)
  const { isDesktop } = useViewport()
  const [defaultValue, setDefaultValue] = React.useState({})
  const { translate } = useInternationalization()

  React.useEffect(() => {
    if(isEdit && form){
      setDefaultValue(form)
    }
    //eslint-disable-next-line
  }, [form])

  const handleInput = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateForm({key, value}))
    }
  }, 250)

  const {
    title_en,
    title_id,
    about_en,
    about_id,
  } = defaultValue

  const handleImage = (e) => {
    if (e) {
      console.log(e)
      const blob = URL.createObjectURL(e)

      handleInput({
        target: {
          name: 'new_image',
          value: {
            name: e.name,
            type: e.type,
            blob
          }
        }
      })
    }
  }

  return (
    <div>
      {
        !isDesktop &&
        <SidebarStatus isEdit={isEdit}/>
      }

      <p className="text-lg font-bold mb-5 lg:mb-8">
        {translate('GENERAL', 'title')}
      </p>
      <FormRow>
        <Label>{translate('GENERAL', 'title')} ({translate('LANGUAGE', 'en')}) <RequiredLabel /></Label>
        <Input
          required
          className="w-full"
          name="title_en"
          defaultValue={title_en}
          onChange={(e) => {e.persist(); handleInput(e)}}
        />
      </FormRow>

      <FormRow last>
        <Label>{translate('GENERAL', 'title')} ({translate('LANGUAGE', 'id')}) <RequiredLabel /></Label>
        <Input
          required
          className="w-full"
          name="title_id"
          defaultValue={title_id}
          onChange={(e) => {e.persist(); handleInput(e)}}
        />
      </FormRow>

      <FormRow>
        <ImagePickerSidebar
          label={translate('GENERAL', 'main_image')}
          height="200px"
          buttonWidth="160px"
          message={translate('GENERAL', 'image_warning')}
          ratio="1:1"
          defaultValue={form.image}
          onChange={handleImage}
        />
      </FormRow>

      <FormOptions />

      <hr className="mb-8"/>

      <p className="text-lg font-bold mb-4">
        {translate('NAVIGATION', 'about')}
      </p>
      <div className="mb-5 lg:mb-8">
        <SpecialRequiredLabel />
      </div>

      <FormRow>
        <Label>{translate('NAVIGATION', 'about')} ({translate('LANGUAGE', 'id')})*</Label>
        <Textarea
          className="w-full"
          rows={10}
          name="about_id"
          defaultValue={about_id}
          onChange={(e) => {e.persist(); handleInput(e)}}
        />
      </FormRow>
      <FormRow>
        <Label>{translate('NAVIGATION', 'about')} ({translate('LANGUAGE', 'en')})*</Label>
        <Textarea
          className="w-full"
          rows={10}
          name="about_en"
          defaultValue={about_en}
          onChange={(e) => {e.persist(); handleInput(e)}}
        />
      </FormRow>
    </div>
  )
}

export { Form }
